module.exports = __webpack_public_path__ + "img/NC_favicon.c98c1339.svg";